import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import mobileIncidentSwitch from "../../../assets/images/featureFlag/incident_switch_mobile.png"
import incidentSwitch from "../../../assets/images/featureFlag/incident_switch.png"
import mobileIncidentSwitchEn from "../../../assets/images/featureFlag/incident_switch_mobile_en.png"
import incidentSwitchEn from "../../../assets/images/featureFlag/incident_switch_en.png"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(41, 98, 255, 0.05) 100%)",
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function IncidentSwitch() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {lang === "ko" ? (
          <img src={isMobile ? mobileIncidentSwitch : incidentSwitch} />
        ) : (
          <img src={isMobile ? mobileIncidentSwitchEn : incidentSwitchEn} />
        )}
      </div>
    </div>
  )
}
